import actions from '../Actions/actions';

const initialState = {
    fetching: false,
    fetched: false,
    error: null,
    statusCode: null,

    children: [
        /*
            {
                ChildBirthDate: "2000-02-12T00:00:00"
                ChildFirstName: "Fjönte"
                ChildGender: "Male"
                ChildLastName: "Jönsson"
                ChildPersonalIdentityNumber: "20000212-1212"
                InsuranceObjectId: 12345
            }
        */
    ]
};

export default function customerChildren(state = initialState, action = {}) {
    let returnState = {...state};

    switch (action.type) {
        case actions.CUSTOMER_CHILDREN_FETCHING_SET:
            returnState = {
                ...state,
                fetching: !!action.payload
            };
            break;
        case actions.CUSTOMER_CHILDREN_SET:
            returnState = {
                ...state,
                children: action.payload
            };
            break;
    }

    return returnState;
}